import { createSelector } from 'reselect';

function selectFilter(state, ownProps) {
  const { filter } = ownProps;

  return filter;
}

// eslint-disable-next-line import/prefer-default-export
export function groupsSelectorFactory() {
  const groups = createSelector([selectFilter], (filter) => filter.get('groups'));

  const isGroupsFetching = createSelector([selectFilter], (filter) => filter.get('isGroupsFetching'));

  return {
    groups,
    isGroupsFetching,
  };
}
